import React, {useState, useContext} from 'react';
import {
  Box,
  Toolbar,
  Typography,
  Container,
  Paper,
  Grid,
  TextField,
} from '@mui/material';
import DashboardTile from '../../components/Tiles/DashboardTile';
import PieChartTile from '../../components/Charts/PieChartTile';
import LineChartTile from '../../components/Charts/LineChartTile';
import Copyright from '../../components/Common/Copyright';
import {Context as DashboardContext} from '../../contexts/DashboardContext';

const boxShadowStyle = {
  boxShadow:
    '0 22px 25px 0 rgb(228 228 234 / 22%), 0 9px 23px 0 rgb(228 228 234 / 50%)',
  '&:hover': {
    boxShadow:
      '0 22px 32px 0 rgb(228 228 234 / 56%), 0 9px 28px 0 rgb(228 228 234 / 64%)',
  },
};

const headerStyle = {
  color: '#9d9db0',
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '1.6px',
  lineHeight: '24px',
  textTransform: 'uppercase',
};

const objectToSortedArray = obj => {
  const array = Object.keys(obj)
    .map(key => {
      return {name: key, value: obj[key]};
    })
    .sort((a, b) => a.value < b.value);
  return array;
};

const objectToArray = obj => {
  const array = Object.keys(obj).map(key => {
    return {name: key, value: obj[key]};
  });

  return array;
};

const toReadable = key => {
  switch (key) {
    case 'creditModule':
      return 'Credit Guide';
    case 'investingModule':
      return 'Investing Guide';
    case 'savingsModule':
      return 'Savings Guide';
    case 'lowCostActivitiesModule':
      return 'Low Cost Activities';
    case 'collegeHacksModule':
      return 'College Hacks';
    case 'jobsForStudentsModule':
      return 'Jobs for Students';
    case 'costOfLivingModule':
      return 'Cost of Living';
    case 'nilModule':
      return 'NIL';
    case 'rentingApartmentModule':
      return 'Renting Apartment';
    case 'retirementAccountsModule':
      return 'Retirement Accounts';
    case 'fafsaModule':
      return 'FAFSA';
    case 'taxesModule':
      return 'Taxes for Employees';
    case 'contractorTaxesModule':
      return 'Taxes for Contractor';
    case 'taxCreditModule':
      return 'Tax Credit';
    case 'creditScoreModule':
      return 'Credit Score';
    case 'whatToInvestInModule':
      return 'What to Invest In';
    case 'emergencyFundModule':
      return 'Emergency Fund';
    case 'managingIncomeModule':
      return 'Managing Income';
    case 'studentLoansModule':
      return 'Student Loans';
    default:
      return key;
  }
};

const GeneralDashboard = ({}) => {
  const {state, getProfiles, getAtRisk} = useContext(DashboardContext);

  const {
    users,
    atRisk,
    askHelp,
    genderBreakdown,
    employmentBreakdown,
    majorBreakdown,
    birthYearBreakdown,
    signUpsSummation,
    appProgress,
    moduleInteraction,
  } = state;

  const moduleArray = Object.keys(moduleInteraction)
    .map(key => {
      return {name: toReadable(key), value: moduleInteraction[key]};
    })
    .sort((a, b) => a.value < b.value);
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: '#fff',
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        padding: '60px',
      }}>
      <Container maxWidth="lg" sx={{mt: 4, mb: 4}}>
        <Grid container spacing={3}>
          {/* TOTAL SIGN UPS */}
          <Grid item xs={12} md={6} lg={4}>
            <DashboardTile header="Total Sign Ups" bigContent={users.length} />
          </Grid>
          {/* ASKED FOR HELP COUNT */}
          <Grid item xs={12} md={4} lg={4}>
            <DashboardTile header="Asked for Help" bigContent={askHelp} />
          </Grid>
          {/* AT RISK */}
          <Grid item xs={12} md={4} lg={4}>
            <DashboardTile header="At Risk" bigContent={atRisk} />
          </Grid>
          {/* STATUS IN APP */}
          <Grid item xs={12} md={6} lg={6}>
            <PieChartTile
              header="App Setup Progress"
              data={[
                {name: 'Not Onboarded', value: appProgress.notOnboarded},
                {
                  name: 'Financial Profile Incomplete',
                  value: appProgress.incomplete,
                },
                {
                  name: 'Complete and Active',
                  value: appProgress.completeActive,
                },
                {
                  name: 'Complete and Inactive',
                  value: appProgress.completeInactive,
                },
              ]}
              slice={8}
              height={'230px'}
            />
          </Grid>
          {/* MAJORS */}
          <Grid item xs={12} md={6} lg={6}>
            <PieChartTile
              header="Majors"
              data={majorBreakdown}
              slice={8}
              height={'352px'}
            />
          </Grid>

          {/* EMPLOYMENT */}
          <Grid item xs={12} md={6} lg={6}>
            <PieChartTile
              header="Employment Status"
              data={employmentBreakdown}
              slice={8}
              height={'230px'}
            />
          </Grid>

          {/* GENDER */}
          <Grid item xs={12} md={6} lg={6}>
            <PieChartTile
              header="Gender"
              data={genderBreakdown}
              slice={8}
              height={'230px'}
            />
          </Grid>
          {/* Birthday */}
          <Grid item xs={12} md={6} lg={6}>
            <PieChartTile
              header="Age"
              data={birthYearBreakdown}
              slice={8}
              height={'230px'}
            />
          </Grid>
          {/* MODULES */}
          <Grid item xs={12} md={6} lg={6}>
            <PieChartTile
              header="Financial Guides Interactions"
              data={moduleArray}
              slice={8}
              height={'230px'}
            />
          </Grid>
          {/* SIGN UPS SUM */}
          <Grid item xs={12} md={12} lg={12}>
            <LineChartTile header="Sign Ups By Day" data={signUpsSummation} />
          </Grid>
        </Grid>
      </Container>
      <Copyright sx={{pt: 4}} />
    </Box>
  );
};

export default GeneralDashboard;
